import {BrowserRouter,Routes,Route } from "react-router-dom";
import Home from "./pages/Home";
import ArticleDetail from "./pages/ArticleDetail";
import ArticleList from "./pages/ArticleList";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/:categoryId" element={<ArticleList/>} />
          <Route path="/:categoryId/:articleId" element={<ArticleDetail/>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
